import styled from "styled-components";
import CheckIcon from '@mui/icons-material/Check';

export const ProfileSearchBarContainer = styled.div`
margin-top: 1.5%;
margin-bottom: 1.5%;
  width: 100%;
  height: 76px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 2.79451px 3.79451px rgba(0, 0, 0, 0.15);
  position: relative;
  justify-content: center;
  margin-bottom: 1.5%;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 20px;
    margin-bottom: 1.5%;
    box-sizing: border-box;
  }
`;

export const ProfileSearchBarElements = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-left: 25px;
  margin-right: 35px;
  gap: 30px;
`;

export const ProfileBar = styled.input`
  width: 100%;
  padding: 10px 15px;
  font-size: 16px;
  border: 1px solid;
  border-radius: 20px;
  outline: none;

  ::placeholder {
    color: #888;
    font-size: 14px;
  }
`;

export const PopoverContainer = styled.div`
  width: 118px;
  height: 142px;
  padding-left: 8px;
  padding-right: 5px;
  margin-bottom: 16px;

  & span,
  & div,
  & p {
    font-family: 'Inter', sans-serif;
    font-size: 10px;
    font-weight: 300;
    padding: 2px;
    margin: 0;
    line-height: 1;
  }

  & h3 {
    font-size: 12px;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    padding-left: 6px;
  }
  
`;


export const CustomCheckIcon = styled(CheckIcon)`
  color: #fe2f67;
  font-size: 10px;
`;

// Cuadrado personalizado (Checkbox)
export const CustomCheckbox = styled("div")<{ checked: boolean }>`
  width: 4px; // Ancho del cuadrado
  height: 4px; // Altura del cuadrado
  border: 0.5px solid ${({ checked }) => (checked ? "black" : "black")};
  background-color: ${({ checked }) => (checked ? "#fe2f67" : "white")};
  cursor: pointer;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border-radius: 2px;
  transition: all 0.2s ease;
`;